import { QueryClient } from 'react-query/core';
import type TokenizedApi from '../TokenizedApi';
import { TokenizedApiError } from '../utils/errors';
import Service from './Service';

/** @category SDK Services */
class TokenizedApiQuery extends Service {
  /** @internal */
  client: QueryClient;

  /** @internal */
  constructor(tokenizedApi: TokenizedApi) {
    super(tokenizedApi);
    this.client =
      tokenizedApi.config.queryClient ||
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            retry: (failureCount, error) => {
              if (error instanceof TokenizedApiError && error?.enableRetries) {
                return failureCount < 3;
              }
              return false;
            },
            // Prevent unnecessary refetching by dependent queries
            staleTime: 45 * 1000,
          },
        },
      });
  }

  getQueryClient() {
    return this.client;
  }

  async reloadAll() {
    await this.client.invalidateQueries(undefined, { refetchInactive: true });
  }
}

export default TokenizedApiQuery;
